import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleRecommend() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-8 md:py-10 bg-background-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-3">
            <div className="w-1 h-5 rounded-full bg-accent-500" />
            <h2 className="text-lg md:text-xl font-heading text-foreground-950">电影资讯</h2>
          </div>
          <Link
            to="/article/a1"
            className="text-sm text-foreground-500 hover:text-accent-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1"
          >
            更多文章
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredArticles.map(article => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/40 hover:border-accent-500/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-background-50/80 text-accent-500 whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 line-clamp-2 group-hover:text-accent-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
                <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/40">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <span className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-eye-line text-xs"></i>
                    </span>
                    {article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}